import {
  CarrierCompany,
  DispatcherInput,
  RateInput,
} from '@cnx-saas/carrier-management';
import { UserLanguages } from '@cnx-saas/common';
import { ShipmentStatus } from './ShipmentStatus';

export enum CarrierCostAdjustmentTypes {
  Discount = 'Discount',
  PriceIncrease = 'PriceIncrease',
}

export class CarrierCostAdjustment {
  type: CarrierCostAdjustmentTypes;
  amount: number;
}

export class ShipmentAssignmentPayload {
  referenceId: string;
  carrier: CarrierCompany;
  dispatcher?: DispatcherInput;
  rate?: RateInput;
  costAdjustment?: CarrierCostAdjustment;
  preferredLanguage?: UserLanguages;
  status?: ShipmentStatus;
}

export class ShipmentAssignment extends ShipmentAssignmentPayload {
  assignedAt: Date;
}
